import React from 'react';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { useIntl } from '@atlassian/jira-intl';
import {
	PeriscopeInsightsSkeleton,
	PeriscopeSuggestionsSkeleton,
	PeriscopeWorkItemsSkeleton,
	DevelopmentPageWorkItemsVulnTabSkeleton,
	DevelopmentPageWorkItemsDeploymentTabSkeleton,
} from '@atlassian/jira-skeletons/src/ui/periscope-page/PeriscopeSuggestionsSkeleton.tsx';
import messages from './messages.tsx';

// Extend this for loading screen
export const Skeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Flex
			xcss={MainContainerStyles}
			data-testId="software-periscope-periscope-page.ui.loading"
			aria-label={formatMessage(messages.label)}
			gap="space.300"
		>
			<Flex xcss={leftColumnStyles} direction="column">
				<Box xcss={InsightsContainerStyles}>
					<PeriscopeInsightsSkeleton />
				</Box>
				<Box xcss={WorkItemsContainerStyles}>
					<PeriscopeWorkItemsSkeleton />
				</Box>
			</Flex>
			<Flex xcss={rightColumnStyles}>
				<Box xcss={SuggestionsContainerStyles}>
					<PeriscopeSuggestionsSkeleton />
				</Box>
			</Flex>
		</Flex>
	);
};

export const InsightsSkeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Box
			xcss={InsightsContainerStyles}
			data-testId="software-periscope-periscope-page.insights-ui.loading"
			aria-label={formatMessage(messages.insightsLabel)}
			paddingBlockEnd="space.400"
		>
			<PeriscopeInsightsSkeleton />
		</Box>
	);
};

export const SuggestionsSkeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Box
			xcss={SuggestionsContainerStyles}
			data-testId="software-periscope-periscope-page.suggestions-ui.loading"
			aria-label={formatMessage(messages.suggestionsLabel)}
			paddingBlockEnd="space.400"
		>
			<PeriscopeSuggestionsSkeleton />
		</Box>
	);
};

// Extend this for loading screen
export const WorkItemsSkeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Box
			xcss={WorkItemsContainerStyles}
			aria-label={formatMessage(messages.workItemsLabel)}
			paddingBlockEnd="space.400"
		>
			<PeriscopeWorkItemsSkeleton />
		</Box>
	);
};

export const WorkItemsVulnTabSkeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Box
			xcss={WorkItemsVulnTabContainerStyles}
			aria-label={formatMessage(messages.workItemsVulnTabLabel)}
		>
			<DevelopmentPageWorkItemsVulnTabSkeleton />
		</Box>
	);
};

export const WorkItemsDeploymentTabSkeleton = () => {
	const { formatMessage } = useIntl();
	return (
		<Box
			xcss={WorkItemsContainerStyles}
			aria-label={formatMessage(messages.workItemsDeploymentTabLabel)}
			paddingBlockEnd="space.400"
		>
			<DevelopmentPageWorkItemsDeploymentTabSkeleton />
		</Box>
	);
};

const MainContainerStyles = xcss({
	width: '100%',
	height: '100%',
	display: 'flex',
	boxSizing: 'border-box',
	overflow: 'hidden',
});

const leftColumnStyles = xcss({
	flex: '2 1 0',
});

const rightColumnStyles = xcss({
	flex: '1 1 0',
});

const SuggestionsContainerStyles = xcss({
	width: '100%',
	overflow: 'hidden',
	height: '650px',
	boxSizing: 'border-box',
});

const InsightsContainerStyles = xcss({
	overflow: 'hidden',
	width: '100%',
	height: '385px',
	boxSizing: 'border-box',
});

const WorkItemsContainerStyles = xcss({
	width: '100%',
	height: '600px',
	boxSizing: 'border-box',
	overflow: 'hidden',
});

const WorkItemsVulnTabContainerStyles = xcss({
	width: '100%',
	height: '420px',
	boxSizing: 'border-box',
	overflow: 'hidden',
});
